import { AddProgressFn } from "ipfs-core-types/dist/src/root";
import { ImportCandidate } from "ipfs-core-types/dist/src/utils";
import { CID, create } from "ipfs-http-client";

const client = create({
  host: "ipfs.infura.io",
  port: 5001,
  protocol: "https",
  headers: {
    authorization:
      "Basic MkNyM0tXSDBJVEZqQlNucVpnOVhEa1V0M1B4OjM0YTA5MDZiMWVkMmVlZWFiNGUyZDkwYTFhN2QzMzg4",
  },
});

export async function uploadFile({
  data,
  progress,
}: {
  data: ImportCandidate;
  progress?: AddProgressFn;
}) {
  return client.add(data, { progress });
}

export async function getFile(value: string | CID) {
  const cid = CID.asCID(value) ?? CID.parse(value as string);

  if (!cid) throw new Error("Invalid CID");

  let data: any[] = [];
  for await (const chunk of client.cat(cid, { preload: true })) {
    data = data.concat(Array.from(chunk));
  }

  return Uint8Array.from(data);
}
